!function() {
    "use strict";
    let l;
    let o = {
        desktop: "",
        tablet: "-tablet",
        mobile: "-mobile"
    }
      , i = (l, o) => "string" != typeof o || !o || (null == o ? void 0 : o.startsWith("#")) || (null == o ? void 0 : o.startsWith("rgb")) || (null == o ? void 0 : o.startsWith("hsl")) || (null == o ? void 0 : o.startsWith("transparent")) ? "" : `gp-${l}-g-${o}`
      , t = (l, o) => o ? Object.entries(o).map( ([o,t]) => "normal" === o ? i(l, t) || "" : i(l, t) ? `${o}:${i(l, t)}` : "").join(" ") : ""
      , e = (l, o, i) => {
        var t, e, d, n, r, v;
        switch (o) {
        case "tablet":
            return null !== (e = null !== (t = null == l ? void 0 : l.tablet) && void 0 !== t ? t : null == l ? void 0 : l.desktop) && void 0 !== e ? e : i;
        case "mobile":
            return null !== (r = null !== (n = null !== (d = null == l ? void 0 : l.mobile) && void 0 !== d ? d : null == l ? void 0 : l.tablet) && void 0 !== n ? n : null == l ? void 0 : l.desktop) && void 0 !== r ? r : i;
        default:
            return null !== (v = null == l ? void 0 : l.desktop) && void 0 !== v ? v : i
        }
    }
      , d = ["desktop", "tablet", "mobile"]
      , n = {
        normal: "",
        hover: "-hvr",
        focus: "-focus"
    }
      , r = l => Object.entries(l).filter( ([,l]) => void 0 !== l).map( ([l,o]) => `${l}: ${o};`).join(" ")
      , v = l => Object.fromEntries(Object.entries(l).map( ([l,o]) => [`--${l}`, o]))
      , u = l => {
        if (l)
            return l && "string" == typeof l && ((null == l ? void 0 : l.startsWith("#")) || (null == l ? void 0 : l.startsWith("rgb")) || (null == l ? void 0 : l.startsWith("RGB")) || (null == l ? void 0 : l.startsWith("hsl")) || (null == l ? void 0 : l.startsWith("transparent")) || (null == l ? void 0 : l.startsWith("linear-gradient"))) ? l : `var(--g-c-${l}, ${l})`
    }
      , s = (l, o) => "string" != typeof o || !o || (null == o ? void 0 : o.startsWith("#")) || (null == o ? void 0 : o.startsWith("rgb")) || (null == o ? void 0 : o.startsWith("hsl")) || (null == o ? void 0 : o.startsWith("transparent")) ? "" : `gp-${l}-g-${o}`
      , a = (l, o) => {
        if (!o)
            return {};
        let i = {
            normal: "",
            hover: "-hvr",
            focus: "-focus"
        };
        return Object.fromEntries(Object.entries(o).map( ([o,t]) => "active" === o ? [] : [`-${null == i ? void 0 : i[o]}-${l}`, u(t)]))
    }
      , c = (l, o) => {
        var i, t, e, d, n, r, v, u, s;
        return o ? {
            [`--${l}`]: null == o ? void 0 : null === (i = o.desktop) || void 0 === i ? void 0 : i.normal,
            [`--hvr-${l}`]: null == o ? void 0 : null === (t = o.desktop) || void 0 === t ? void 0 : t.hover,
            [`--focus-${l}`]: null == o ? void 0 : null === (e = o.desktop) || void 0 === e ? void 0 : e.focus,
            [`--${l}-tablet`]: null == o ? void 0 : null === (d = o.tablet) || void 0 === d ? void 0 : d.normal,
            [`--hvr-${l}-tablet`]: null == o ? void 0 : null === (n = o.tablet) || void 0 === n ? void 0 : n.hover,
            [`--focus-${l}-tablet`]: null == o ? void 0 : null === (r = o.tablet) || void 0 === r ? void 0 : r.focus,
            [`--${l}-mobile`]: null == o ? void 0 : null === (v = o.mobile) || void 0 === v ? void 0 : v.normal,
            [`--hvr-${l}-mobile`]: null == o ? void 0 : null === (u = o.mobile) || void 0 === u ? void 0 : u.hover,
            [`--focus-${l}-mobile`]: null == o ? void 0 : null === (s = o.mobile) || void 0 === s ? void 0 : s.focus
        } : {}
    }
      , m = l => {
        var o, i, t, e, d, n, r, v, u, s, a, m, p, h, g, f, y, $, x, L, w, k, S;
        if (!l)
            return;
        if ("desktop"in l || "tablet"in l || "mobile"in l) {
            let o = {
                desktop: {
                    normal: null === (n = l.desktop) || void 0 === n ? void 0 : null === (d = n.normal) || void 0 === d ? void 0 : d.border,
                    hover: null === (v = l.desktop) || void 0 === v ? void 0 : null === (r = v.hover) || void 0 === r ? void 0 : r.border,
                    focus: null === (s = l.desktop) || void 0 === s ? void 0 : null === (u = s.focus) || void 0 === u ? void 0 : u.border
                },
                tablet: {
                    normal: null === (m = l.tablet) || void 0 === m ? void 0 : null === (a = m.normal) || void 0 === a ? void 0 : a.border,
                    hover: null === (h = l.tablet) || void 0 === h ? void 0 : null === (p = h.hover) || void 0 === p ? void 0 : p.border,
                    focus: null === (f = l.tablet) || void 0 === f ? void 0 : null === (g = f.focus) || void 0 === g ? void 0 : g.border
                },
                mobile: {
                    normal: null === ($ = l.mobile) || void 0 === $ ? void 0 : null === (y = $.normal) || void 0 === y ? void 0 : y.border,
                    hover: null === (L = l.mobile) || void 0 === L ? void 0 : null === (x = L.hover) || void 0 === x ? void 0 : x.border,
                    focus: null === (k = l.mobile) || void 0 === k ? void 0 : null === (w = k.focus) || void 0 === w ? void 0 : w.border
                }
            };
            return c("bs", o)
        }
        let A = {
            normal: null == l ? void 0 : null === (o = l.normal) || void 0 === o ? void 0 : o.border,
            hover: null !== (S = null == l ? void 0 : null === (i = l.hover) || void 0 === i ? void 0 : i.border) && void 0 !== S ? S : null == l ? void 0 : null === (t = l.normal) || void 0 === t ? void 0 : t.border,
            focus: null == l ? void 0 : null === (e = l.focus) || void 0 === e ? void 0 : e.border
        };
        return b("bs", A)
    }
      , p = l => {
        var o, i, t, e, d, n, r, v, u, s, a, m, p, h, g, f, y, $, x, L, w, k, S, A, q, H, E, j, O, W, I, B;
        if (!l)
            return;
        if ("desktop"in l || "tablet"in l || "mobile"in l) {
            let o = {
                desktop: {
                    normal: null === (n = l.desktop) || void 0 === n ? void 0 : null === (d = n.normal) || void 0 === d ? void 0 : d.width,
                    hover: null !== (O = null === (v = l.desktop) || void 0 === v ? void 0 : null === (r = v.hover) || void 0 === r ? void 0 : r.width) && void 0 !== O ? O : null === (s = l.desktop) || void 0 === s ? void 0 : null === (u = s.normal) || void 0 === u ? void 0 : u.width,
                    focus: null === (m = l.desktop) || void 0 === m ? void 0 : null === (a = m.focus) || void 0 === a ? void 0 : a.width
                },
                tablet: {
                    normal: null === (h = l.tablet) || void 0 === h ? void 0 : null === (p = h.normal) || void 0 === p ? void 0 : p.width,
                    hover: null !== (W = null === (f = l.tablet) || void 0 === f ? void 0 : null === (g = f.hover) || void 0 === g ? void 0 : g.width) && void 0 !== W ? W : null === ($ = l.tablet) || void 0 === $ ? void 0 : null === (y = $.normal) || void 0 === y ? void 0 : y.width,
                    focus: null === (L = l.tablet) || void 0 === L ? void 0 : null === (x = L.focus) || void 0 === x ? void 0 : x.width
                },
                mobile: {
                    normal: null === (k = l.mobile) || void 0 === k ? void 0 : null === (w = k.normal) || void 0 === w ? void 0 : w.width,
                    hover: null !== (I = null === (A = l.mobile) || void 0 === A ? void 0 : null === (S = A.hover) || void 0 === S ? void 0 : S.width) && void 0 !== I ? I : null === (H = l.mobile) || void 0 === H ? void 0 : null === (q = H.normal) || void 0 === q ? void 0 : q.width,
                    focus: null === (j = l.mobile) || void 0 === j ? void 0 : null === (E = j.focus) || void 0 === E ? void 0 : E.width
                }
            };
            return c("bw", o)
        }
        let N = {
            normal: null == l ? void 0 : null === (o = l.normal) || void 0 === o ? void 0 : o.width,
            hover: null !== (B = null == l ? void 0 : null === (i = l.hover) || void 0 === i ? void 0 : i.width) && void 0 !== B ? B : null == l ? void 0 : null === (t = l.normal) || void 0 === t ? void 0 : t.width,
            focus: null == l ? void 0 : null === (e = l.focus) || void 0 === e ? void 0 : e.width
        };
        return b("bw", N)
    }
      , h = l => {
        var o, i, t, e, d, n, r, v, u, s, c, m, p, h, b, f, y, $, x, L, w, k, S, A, q, H, E, j, O, W, I, B;
        if (!l)
            return;
        if ("desktop"in l || "tablet"in l || "mobile"in l) {
            let o = {
                desktop: {
                    normal: null === (n = l.desktop) || void 0 === n ? void 0 : null === (d = n.normal) || void 0 === d ? void 0 : d.color,
                    hover: null !== (O = null === (v = l.desktop) || void 0 === v ? void 0 : null === (r = v.hover) || void 0 === r ? void 0 : r.color) && void 0 !== O ? O : null === (s = l.desktop) || void 0 === s ? void 0 : null === (u = s.normal) || void 0 === u ? void 0 : u.color,
                    focus: null === (m = l.desktop) || void 0 === m ? void 0 : null === (c = m.focus) || void 0 === c ? void 0 : c.color
                },
                tablet: {
                    normal: null === (h = l.tablet) || void 0 === h ? void 0 : null === (p = h.normal) || void 0 === p ? void 0 : p.color,
                    hover: null !== (W = null === (f = l.tablet) || void 0 === f ? void 0 : null === (b = f.hover) || void 0 === b ? void 0 : b.color) && void 0 !== W ? W : null === ($ = l.tablet) || void 0 === $ ? void 0 : null === (y = $.normal) || void 0 === y ? void 0 : y.color,
                    focus: null === (L = l.tablet) || void 0 === L ? void 0 : null === (x = L.focus) || void 0 === x ? void 0 : x.color
                },
                mobile: {
                    normal: null === (k = l.mobile) || void 0 === k ? void 0 : null === (w = k.normal) || void 0 === w ? void 0 : w.color,
                    hover: null !== (I = null === (A = l.mobile) || void 0 === A ? void 0 : null === (S = A.hover) || void 0 === S ? void 0 : S.color) && void 0 !== I ? I : null === (H = l.mobile) || void 0 === H ? void 0 : null === (q = H.normal) || void 0 === q ? void 0 : q.color,
                    focus: null === (j = l.mobile) || void 0 === j ? void 0 : null === (E = j.focus) || void 0 === E ? void 0 : E.color
                }
            };
            return g("bc", o)
        }
        let N = {
            normal: null == l ? void 0 : null === (o = l.normal) || void 0 === o ? void 0 : o.color,
            hover: null !== (B = null == l ? void 0 : null === (i = l.hover) || void 0 === i ? void 0 : i.color) && void 0 !== B ? B : null == l ? void 0 : null === (t = l.normal) || void 0 === t ? void 0 : t.color,
            focus: null == l ? void 0 : null === (e = l.focus) || void 0 === e ? void 0 : e.color
        };
        return a("bc", N)
    }
      , g = (l, o) => o ? Object.entries(o).map( ([o,i]) => "desktop" === o ? Object.fromEntries(Object.entries(i).map( ([o,i]) => "active" === o ? [] : [`-${n[o]}-${l}`, u(i)])) : Object.fromEntries(Object.entries(i).map( ([i,t]) => "active" === i ? [] : [`-${n[i]}-${l}-${o}`, u(t)]))).reduce( (l, o) => ({
        ...l,
        ...o
    }), {}) : {}
      , b = (l, o) => o ? {
        [`--${l}`]: null == o ? void 0 : o.normal,
        [`--hvr-${l}`]: null == o ? void 0 : o.hover,
        [`--focus-${l}`]: null == o ? void 0 : o.focus
    } : {}
      , f = (l, o) => ({
        [`--${l}`]: null == o ? void 0 : o.desktop,
        [`--${l}-tablet`]: null == o ? void 0 : o.tablet,
        [`--${l}-mobile`]: null == o ? void 0 : o.mobile
    });
    function y(l, i) {
        var t, e, d, n, r;
        if (!l || !i)
            return {};
        let v = null !== (r = o[i]) && void 0 !== r ? r : "";
        return {
            [`--pl${v}`]: null == l ? void 0 : null === (t = l[i]) || void 0 === t ? void 0 : t.horizontal,
            [`--pr${v}`]: null == l ? void 0 : null === (e = l[i]) || void 0 === e ? void 0 : e.horizontal,
            [`--pt${v}`]: null == l ? void 0 : null === (d = l[i]) || void 0 === d ? void 0 : d.vertical,
            [`--pb${v}`]: null == l ? void 0 : null === (n = l[i]) || void 0 === n ? void 0 : n.vertical
        }
    }
    let $ = l => Object.assign({}, y(l, "desktop"), y(l, "tablet"), y(l, "mobile"))
      , x = l => ({
        width: f("w", L("width", l)),
        height: f("h", L("height", l)),
        padding: w(l),
        gap: S(l)
    })
      , L = (l, o) => {
        if (!o)
            return {};
        let i = {};
        return d.forEach(t => {
            var d;
            i = {
                ...i,
                [t]: null === (d = e(o, t)) || void 0 === d ? void 0 : d[l]
            }
        }
        ),
        i
    }
      , w = l => Object.assign({}, k(l, "desktop"), k(l, "tablet"), k(l, "mobile"));
    function k(l, i) {
        var t, e, d, n, r, v, u, s, a;
        if (!l || !i)
            return {};
        let c = null !== (a = o[i]) && void 0 !== a ? a : "";
        return {
            [`--pl${c}`]: null == l ? void 0 : null === (e = l[i]) || void 0 === e ? void 0 : null === (t = e.padding) || void 0 === t ? void 0 : t.left,
            [`--pr${c}`]: null == l ? void 0 : null === (n = l[i]) || void 0 === n ? void 0 : null === (d = n.padding) || void 0 === d ? void 0 : d.right,
            [`--pt${c}`]: null == l ? void 0 : null === (v = l[i]) || void 0 === v ? void 0 : null === (r = v.padding) || void 0 === r ? void 0 : r.top,
            [`--pb${c}`]: null == l ? void 0 : null === (s = l[i]) || void 0 === s ? void 0 : null === (u = s.padding) || void 0 === u ? void 0 : u.bottom
        }
    }
    let S = l => {
        var o, i, t;
        return {
            "--gg": null == l ? void 0 : null === (o = l.desktop) || void 0 === o ? void 0 : o.gap,
            "--gg-tablet": null == l ? void 0 : null === (i = l.tablet) || void 0 === i ? void 0 : i.gap,
            "--gg-mobile": null == l ? void 0 : null === (t = l.mobile) || void 0 === t ? void 0 : t.gap
        }
    }
      , A = (l, o, i) => {
        let t = l.getAttribute("gp-data-interaction")
          , e = JSON.parse(t || "{}");
        l.setAttribute("gp-data-interaction", JSON.stringify({
            ...e,
            [o]: i
        }))
    }
      , q = () => {
        window.removeEventListener("gp-global-loaded", q),
        customElements.get("gp-accordion") || customElements.define("gp-accordion", class extends GP.Component {
            constructor() {
                var o, i, e, d, n, c, g, b, f, y, L, w, k, S, q, H;
                let E;
                super();
                let j = ".gp-accordion-item_header"
                  , O = ".gp-accordion-item_body"
                  , W = ".gp-accordion-item_body-inner"
                  , I = "text-only"
                  , B = ".gp-accordion-item"
                  , N = !1
                  , T = this.getState()
                  , R = []
                  , _ = []
                  , {activeKey: C, expandItem: J, iconPosition: z, iconCollapse: G, iconExpand: M, iconCollapseSize: P, expandedMode: D, configIconSize: F, parentUid: K, childListNumber: Q, iconSvg: U, layoutHeader: V, controlledByParent: X=!1} = (null == T ? void 0 : T.setting) || {}
                  , {bgColor: Y, color: Z, headerBorder: ll, itemHeaderSpacing: lo, itemContentSpacing: li, textColor: lt, iconColor: le, contentSizePadding: ld, headerContentPadding: ln, widthHeightSize: lr} = (null == T ? void 0 : T.styles) || {}
                  , lv = this.getAttribute("data-id") || "";
                J && C && (E = (parseInt(`${C}`) - 1).toString());
                let lu = x(ld)
                  , ls = () => {
                    let l = {
                        ...ld && lu.padding,
                        ...(null == li ? void 0 : li.type) || ld ? {} : $(null == li ? void 0 : li.custom)
                    };
                    return l
                }
                  , la = this.querySelectorAll(B)
                  , lc = this.querySelectorAll(".gp-accordion-item_body");
                lc.length > 0 && lc.forEach(l => {
                    var o;
                    let i = l.querySelector(W);
                    i && i.setAttribute("style", r(ls())),
                    l.style.gridTemplateRows = "unset",
                    l.style.maxHeight = "0px",
                    null === (o = l.dataset) || void 0 === o || delete o.show
                }
                );
                let lm = this.querySelectorAll(j)
                  , lp = x(ln)
                  , lh = x(lr);
                R = [];
                let lg = Array.isArray(Q) && Q.length > 0
                  , lb = Array.isArray(Q) ? Q.map(String) : []
                  , lf = !X || K === lv
                  , ly = lb.length > 0 && lf;
                R = ly ? lb : J && null != E ? [E] : [];
                let l$ = X && lg && Q.length > 1 && K === lv
                  , lx = !X && lg && Q.length > 1;
                _ = [];
                let lL = {
                    ...lh.height,
                    ...ln && lp.padding,
                    ...(null == lo ? void 0 : lo.type) || ln ? {} : $(null == lo ? void 0 : lo.custom),
                    ...v({
                        fd: "left" === z ? "row" : "row-reverse",
                        jc: "right" === z ? "space-between" : ""
                    }),
                    ...lu.gap
                }
                  , lw = r({
                    ...v({
                        bgc: u(null !== (L = null == Y ? void 0 : Y.active) && void 0 !== L ? L : null == Y ? void 0 : Y.normal),
                        bs: null !== (w = null == ll ? void 0 : null === (o = ll.active) || void 0 === o ? void 0 : o.border) && void 0 !== w ? w : null == ll ? void 0 : null === (i = ll.normal) || void 0 === i ? void 0 : i.border,
                        bw: null !== (k = null == ll ? void 0 : null === (e = ll.active) || void 0 === e ? void 0 : e.width) && void 0 !== k ? k : null == ll ? void 0 : null === (d = ll.normal) || void 0 === d ? void 0 : d.width,
                        bc: u(null !== (S = null == ll ? void 0 : null === (n = ll.active) || void 0 === n ? void 0 : n.color) && void 0 !== S ? S : null == ll ? void 0 : null === (c = ll.normal) || void 0 === c ? void 0 : c.color),
                        c: u(null !== (q = null == lt ? void 0 : lt.active) && void 0 !== q ? q : null == lt ? void 0 : lt.normal) + "!important"
                    }),
                    ...lL
                })
                  , lk = r({
                    ...v({
                        c: u(null !== (H = null == Z ? void 0 : Z.active) && void 0 !== H ? H : null == Z ? void 0 : Z.normal) + "!important"
                    }),
                    width: `${P || 16}px`,
                    height: `${P || 16}px`
                })
                  , lS = r({
                    ...a("bgc", Y),
                    ...a("c", lt),
                    ...m(ll),
                    ...p(ll),
                    ...h(ll),
                    ...v({
                        c: u(null == lt ? void 0 : lt.normal)
                    }),
                    ...lL
                })
                  , lA = r({
                    ...a("c", Z),
                    width: `${P || 16}px`,
                    height: `${P || 16}px`
                })
                  , lq = [...(null === (g = t("bg", Y).trim().split(" ")[0]) || void 0 === g ? void 0 : g.length) ? t("bg", Y).trim().split(" ") : [], ...(null === (b = t("text", lt).trim().split(" ")[0]) || void 0 === b ? void 0 : b.length) ? t("text", lt).trim().split(" ") : []].filter(l => "" != l)
                  , lH = [...(null === (f = t("text", Z).trim().split(" ")[0]) || void 0 === f ? void 0 : f.length) ? t("text", Z).trim().split(" ") : []].filter(l => "" != l)
                  , lE = [...s("bg", null == Y ? void 0 : Y.active).trim().split(" "), ...s("text", null == lt ? void 0 : lt.active).trim().split(" ")].filter(l => "" != l)
                  , lj = [...s("text", null == Z ? void 0 : Z.active).trim().split(" ")].filter(l => "" != l)
                  , lO = (l, o) => {
                    var i, t;
                    let e = l.$itemHeader
                      , d = l.$itemIcon
                      , n = l.$itemBody
                      , r = null !== (i = null == lq ? void 0 : lq.length) && void 0 !== i ? i : 0
                      , v = null !== (t = null == lH ? void 0 : lH.length) && void 0 !== t ? t : 0;
                    e && r > 0 && e.classList.add(...lq),
                    d && v > 0 && d.classList.add(...lH),
                    !o && n && n.classList.add("gp-hidden")
                }
                  , lW = (l, o) => {
                    var i, t;
                    let e = l.$itemHeader
                      , d = l.$itemIcon
                      , n = l.$itemBody
                      , r = null !== (i = null == lq ? void 0 : lq.length) && void 0 !== i ? i : 0
                      , v = null !== (t = null == lH ? void 0 : lH.length) && void 0 !== t ? t : 0;
                    e && r > 0 && e.classList.remove(...lq),
                    d && v > 0 && d.classList.remove(...lH),
                    !o && n && n.classList.remove("gp-hidden")
                }
                  , lI = (l, o) => {
                    let i = l.$itemHeader
                      , t = l.$itemIcon
                      , e = l.$itemBody;
                    i && (lE.length && i.classList.add(...lE),
                    i.setAttribute("style", lw)),
                    t && (lj.length && t.classList.add(...lj),
                    t.setAttribute("style", lk)),
                    !o && e && e.classList.add("gp-block")
                }
                  , lB = (l, o) => {
                    let i = l.$itemHeader
                      , t = l.$itemIcon
                      , e = l.$itemBody;
                    i && (lE.length && i.classList.remove(...lE),
                    i.setAttribute("style", lS)),
                    t && (lj.length && t.classList.remove(...lj),
                    t.setAttribute("style", lA)),
                    !o && e && e.classList.remove("gp-block")
                }
                  , lN = l => {
                    l && (null == l || l.classList.add("!gp-text-[var(--icon-expand-active-color)]"),
                    null == l || l.classList.remove("group-hover:[color:var(--icon-expand-hover-color)]"),
                    lT(!0) && (l.innerHTML = lT(!0)),
                    "plus" === U || M || (l.classList.remove("gp-rotate-90"),
                    l.classList.add("-gp-rotate-90")),
                    "plus" !== U || M || (l.classList.remove("gp-rotate-90"),
                    l.classList.add("gp-rotate-180")),
                    M && (l.classList.remove("gp--rotate-90"),
                    l.classList.remove("gp-rotate-90")))
                }
                  , lT = l => M && l ? M : G && !l ? G : U
                  , lR = l => {
                    l && (null == l || l.classList.add("group-hover:[color:var(--icon-expand-hover-color)]"),
                    lT(!1) && (l.innerHTML = lT(!1)),
                    "plus" === U && l.classList.remove("gp-rotate-180"),
                    G ? (l.classList.remove("gp--rotate-90"),
                    l.classList.remove("gp-rotate-90")) : (l.classList.remove("gp--rotate-90"),
                    l.classList.add("gp-rotate-90")))
                }
                  , l_ = l => {
                    l.classList.remove("group-hover:[color:var(--icon-hover-color)]", "!gp-text-[var(--icon-active-color)]"),
                    null == l || l.setAttribute("style", r({
                        width: F ? `${F}px` : "16px",
                        height: F ? `${F}px` : "16px",
                        ...v({
                            c: u(null == le ? void 0 : le.normal)
                        })
                    }))
                }
                  , lC = l => {
                    null == l || l.classList.add("!gp-text-[var(--icon-active-color)]"),
                    null == l || l.setAttribute("style", r({
                        width: F ? `${F}px` : "16px",
                        height: F ? `${F}px` : "16px",
                        ...v({
                            c: u(null == le ? void 0 : le.active)
                        })
                    }))
                }
                  , lJ = (l, o) => {
                    let i = l.querySelector(".gp-collapsible-icon");
                    lT(o) ? (l.style.gap = "16px",
                    i && (i.style.display = "")) : (i && (i.style.display = "none"),
                    l.style.gap = "")
                }
                  , lz = l => ({
                    $item: l,
                    $itemHeader: l.querySelector(j),
                    $itemIcon: l.querySelector(".gp-accordion-item_icon"),
                    $itemBody: l.querySelector(O),
                    $itemHeaderIcon: l.querySelector(".header-icon"),
                    $itemBodyInner: l.querySelector(W),
                    $textItem: l.querySelector(".gp-accordion-text-content")
                })
                  , lG = (l, o) => ({
                    hasItemBodyInner: !!o,
                    isCurrentlyExpanded: R.includes(l.toString()),
                    wasPreviouslyExpanded: _.includes(l.toString())
                })
                  , lM = (l, o, i, t, e) => {
                    let {$item: d, $itemHeader: n, $itemIcon: v, $itemBody: s, $textItem: a} = l;
                    lI(l, o),
                    lW(l, o),
                    lN(v),
                    a && (a.classList.remove("group-hover:[color:var(--text-hover-color)!important]"),
                    a.style.color = u(null == lt ? void 0 : lt.active)),
                    V !== I && i && (i.classList.add("group-hover:[color:var(--icon-hover-color)]", "!gp-text-[var(--icon-active-color)]"),
                    i.classList.remove("group-hover:[color:var(--icon-hover-color)!important]"),
                    lC(i)),
                    e && d && lF(d, {
                        dataId: e,
                        hover: !1
                    }),
                    n && lJ(n, !0),
                    o && s && t && (s.style.gridTemplateRows = "unset",
                    s.style.maxHeight = N ? `${s.scrollHeight}px` : "fit-content",
                    s.addEventListener("transitionend", function() {
                        "0px" !== s.style.maxHeight && (s.style.maxHeight = "")
                    }, {
                        once: !0
                    }),
                    t.setAttribute("style", r(ls())))
                }
                  , lP = (l, o, i, t) => {
                    let {$item: e, $itemHeader: d, $itemIcon: n, $itemBody: r, $textItem: v} = l;
                    lB(l, o),
                    lR(n),
                    lO(l, o),
                    V !== I && i && (i.classList.add("group-hover:[color:var(--icon-hover-color)!important]"),
                    l_(i)),
                    t && e && lF(e, {
                        dataId: t,
                        hover: !0
                    }),
                    d && lJ(d, !1),
                    o && r && (r.style.maxHeight = `${r.scrollHeight}px`,
                    r.offsetHeight,
                    r.style.maxHeight = "0px"),
                    v && (v.classList.add("group-hover:[color:var(--text-hover-color)!important]"),
                    v.style.color = u(null == lt ? void 0 : lt.normal))
                }
                  , lD = l => {
                    let o = this.querySelectorAll(B);
                    o.forEach(o => {
                        let i = (null == o ? void 0 : o.className.split(" ")[0]) || "";
                        if (i === l) {
                            let l = o.getAttribute("data-index") || ""
                              , i = lz(o)
                              , {$itemHeaderIcon: t, $itemBodyInner: e} = i
                              , {hasItemBodyInner: d, isCurrentlyExpanded: n, wasPreviouslyExpanded: r} = lG(l, i.$itemBodyInner);
                            n !== r && (n ? lM(i, d, t, e, l) : lP(i, d, t, l))
                        }
                    }
                    ),
                    N = !0,
                    _ = [...R]
                }
                  , lF = (l, o) => {
                    let i = l.querySelector("style");
                    if (i) {
                        let i = this.querySelector('style[title="gp-accordion-item-style"]');
                        if (i) {
                            let i = l.querySelector(".gp-collapsible-icon")
                              , t = l.querySelector(".gp-icon");
                            if (null == o ? void 0 : o.hover) {
                                null == i || i.classList.add("gp-accordion-item-hover"),
                                null == t || t.classList.add("gp-accordion-item-hover"),
                                null == i || i.classList.remove("gp-accordion-item-active"),
                                null == t || t.classList.remove("gp-accordion-item-active");
                                return
                            }
                            null == i || i.classList.remove("gp-accordion-item-hover"),
                            null == t || t.classList.remove("gp-accordion-item-hover"),
                            null == i || i.classList.add("gp-accordion-item-active"),
                            null == t || t.classList.add("gp-accordion-item-active");
                            return
                        }
                    }
                }
                  , lK = l => {
                    R = "multiple" === D || l$ || lx ? R.includes(l) ? R.filter(o => o !== l) : [...R, l] : R.includes(l) ? [] : [l]
                }
                  , lQ = (l, o) => {
                    let i = "multiple" !== D && R[0] || null
                      , t = l.parentElement;
                    if (!i || i === o || !t)
                        return 0;
                    let e = this.querySelector(`${B}[data-index='${i}']`)
                      , d = null == e ? void 0 : e.querySelector(O)
                      , n = t.querySelector(O);
                    if (!d || !n)
                        return 0;
                    let r = d.scrollHeight
                      , v = n.scrollHeight
                      , u = v - r
                      , s = this.getBoundingClientRect().top;
                    return s >= 0 && (u = 0),
                    u
                }
                ;
                ( () => {
                    lm.forEach(l => {
                        l.addEventListener("click", () => {
                            var o;
                            let i = (null === (o = l.parentElement) || void 0 === o ? void 0 : o.className.split(" ")[0]) || "";
                            if (K !== i)
                                return;
                            let t = l.getAttribute("data-index") || ""
                              , e = lQ.call(this, l, t);
                            lK(t),
                            lD(i),
                            0 !== e && window.scrollBy(0, e)
                        }
                        )
                    }
                    )
                }
                )();
                let lU = (null === (y = la[0]) || void 0 === y ? void 0 : y.className.split(" ")[0]) || lv;
                _ = [],
                lD(lU),
                _ = [...R];
                let lV = l => {
                    var o;
                    let {data: i, isRollback: t=!1, key: e, expandItems: d=[]} = l || {}
                      , n = this.getAttribute("data-id") || ""
                      , r = "multiple" === D || l$ || lx
                      , v = i.toString()
                      , u = R.includes(v);
                    if (t) {
                        lX({
                            isExpanded: u,
                            allowOpenMultiple: r,
                            dataString: v,
                            expandItems: d,
                            uid: n
                        });
                        return
                    }
                    if (u)
                        return;
                    lY({
                        element: this,
                        key: e,
                        data: i,
                        isExpanded: u,
                        expandItems: R
                    }),
                    R = r ? [...R, v] : [v];
                    let s = (null === (o = la[0]) || void 0 === o ? void 0 : o.className.split(" ")[0]) || n;
                    lD(s)
                }
                  , lX = l => {
                    var o;
                    let {isExpanded: i, allowOpenMultiple: t, dataString: e, expandItems: d, uid: n} = l;
                    if (t) {
                        if (!i)
                            return;
                        R = R.filter(l => l !== e)
                    } else
                        R = d;
                    let r = (null === (o = la[0]) || void 0 === o ? void 0 : o.className.split(" ")[0]) || n;
                    lD(r)
                }
                  , lY = l => {
                    let {element: o, key: i, data: t, isExpanded: e, expandItems: d} = l;
                    A(o, i, JSON.stringify({
                        data: t,
                        expanded: e,
                        expandItems: d
                    }))
                }
                ;
                if (!this.onTrigger)
                    return;
                this.onTrigger({
                    event: "gp:change-expanded-item-original"
                }, o => {
                    clearTimeout(l),
                    l = setTimeout( () => {
                        lV(o)
                    }
                    , 0)
                }
                )
            }
        }
        )
    }
    ;
    "completed" === window.gpReadyState ? q() : window.addEventListener("gp-global-loaded", q)
}();
